module.exports = __webpack_public_path__ + "static/media/carroussel_03.1f20e9c2.jpg";